<template>
  <ResponsiveLayout
    sticky-actions
    :progress="progress"
  >
    <template
      v-if="canGoBack"
      #header_start
    >
      <ButtonBack @click="navigateBack" />
    </template>
    <template #header_end><HeaderHelp /></template>

    <div
      v-if="practice"
      class="kds-main-wrapper"
    >
      <div class="kds-content-block">
        <p class="kds-typography-title-xlarge">
          {{ $t('eu__doctor_outreach_practice_confirmation__title') }}
        </p>
      </div>

      <BaseBanner
        variant="neutral"
        data-qa="doctor-practice"
        :title="practice.name"
      >
        <p class="kds-typography-paragraph-medium">
          {{ practice.address }}
          <br />
          {{ postalCodeAndCity }}
        </p>
      </BaseBanner>
    </div>

    <template #actions>
      <BaseButton
        :text="$t('eu__doctor_outreach_practice_confirmation__submit')"
        data-qa="submit"
        @click="handleConfirm"
      />
      <BaseButton
        :text="$t('eu__doctor_outreach_practice_confirmation__change_doctor')"
        variant="outlined"
        data-qa="change-doctor"
        @click="navigateToAddPrescriber"
      />
    </template>
  </ResponsiveLayout>
</template>

<script setup>
import { computed } from 'vue'
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'
import ButtonBack from '@shared/components/ButtonBack.vue'
import HeaderHelp from '@eu/app/components/HeaderHelp.vue'
import BaseBanner from '@shared/components/BaseBanner.vue'
import BaseButton from '@shared/components/BaseButton.vue'
import ROUTE from '@eu/app/router/appModule/names.js'
import useOnboardingProgress from '@eu/app/composables/useOnboardingProgress.js'
import useDoctorOutreachStore from '@eu/app/stores/useDoctorOutreachStore.js'
import Tracker from '@shared/Tracker.js'
import useNavigation from '@eu/app/composables/useNavigation'

const { progress } = useOnboardingProgress()
const { navigateNext, navigateBack, canGoBack } = useNavigation(
  ROUTE.DOCTOR_OUTREACH_PRACTICE_CONFIRMATION,
)
const doctorOutreachStore = useDoctorOutreachStore()

const practice = computed(() => doctorOutreachStore.resolvedPractice)

const postalCodeAndCity = computed(() =>
  [practice.value?.postal_code, practice.value?.city].filter(Boolean).join(' '),
)

const handleConfirm = () => {
  Tracker.trackButtonSelect('submit', 'doctor_outreach_practice_confirmation')
  doctorOutreachStore.prescriberRequest = null
  doctorOutreachStore.selectedPracticeId = practice.value.id
  navigateNext('confirmed')
}

const navigateToAddPrescriber = () => {
  Tracker.trackButtonSelect(
    'change_doctor',
    'doctor_outreach_practice_confirmation',
  )
  navigateNext('changeDoctor')
}
</script>
